import axios from "../../../services/axios-config.js";

export async function unlinkCommissionedCompany({ mapId }) {
  const res = await axios.post("/commissioned/companies/unlink", { mapId });
  return res?.data;
}
